import React   from "react"
import {Link}  from "react-router-dom"
import { useTranslation } from 'react-i18next';
import Footer from "components/SelfCheckin/Footer/Footer"
import {
  ButtonTypeEnum, ButtonSizeEnum, ButtonColorEnum
} from "components/shared/enums/global-enums.tsx";
import AppButton from "components/shared/AppButton/AppButton"
import {AppRoutes} from "utils/routes";
import useStore from 'store/store'
import './DemoChoices.scss'


export default function DemoChoices(){
  const {t} = useTranslation();
  const storeActions = useStore((state)=> state.actions);
  const touchpointLebel = storeActions.retrieveItem("touchpoint-label");

  return (
    <div  className="dc-cover-bloc"   >

      <div className="h3 white-color font-1-heavy upper">TOUCHPOINT {touchpointLebel}</div> 
      <div>
        <Link to={AppRoutes.selfCheckinPath}>
          <AppButton 
            sx={{width: '240px', margin:2, fontWeight: '700', textTransform: 'uppercase'}}
            buttonColor={ButtonColorEnum.WHITE_BG_THIRD}
            buttonLabel={ t("Check-In Demo")}
            buttonType={ButtonTypeEnum.PRIMARY}
            buttonSize={ButtonSizeEnum.LARGE}
          />
        </Link>
        <Link to={AppRoutes.selfBoardingPath}>
          <AppButton 
            sx={{width: '240px', margin:2, fontWeight: '700', textTransform: 'uppercase'}}
            buttonColor={ButtonColorEnum.WHITE_BG_THIRD}
            buttonLabel={ t("Boarding Demo")}
            buttonType={ButtonTypeEnum.PRIMARY}
            buttonSize={ButtonSizeEnum.LARGE}
          />
        </Link>
      </div>

      <Footer />

    </div>
    )
}